import { useEffect, useCallback } from "react";
import classnames from "classnames";

const Modal = ({
  isOpen,
  size = "lg",
  children,
  handleClose,
  allowOverflow,
}) => {
  /* Close on Escape key */
  const onKeyDown = useCallback(
    (e) => {
      if (e.key === "Escape") handleClose?.();
    },
    [handleClose]
  );

  useEffect(() => {
    if (!isOpen) return;

    document.addEventListener("keydown", onKeyDown);
    /* Prevent background scroll when modal is open */
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = "";
    };
  }, [isOpen, onKeyDown]);

  if (!isOpen) return null;

  const containerClass = classnames(
    "relative bg-card text-card-foreground rounded-lg shadow-lg",
    "w-full transform transition-all",
    "sm:my-8 sm:mx-auto",
    {
      "overflow-hidden": !allowOverflow,
      "sm:max-w-[830px]": size === "xl",
      "sm:max-w-lg": size === "lg",
      "sm:max-w-sm": size === "sm",
    }
  );

  return (
    <div
      className="fixed inset-0 z-50 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div className="flex min-h-screen items-center justify-center p-4">
        {/* Backdrop */}
        <div
          onClick={() => handleClose?.()}
          className="fixed inset-0 bg-foreground/20 backdrop-blur-sm transition-opacity"
          aria-hidden="true"
        />

        {/* Panel */}
        <div className={containerClass}>{children}</div>
      </div>
    </div>
  );
};

export default Modal;
